import React, { Component } from "react";

import Routes from "./Components/Routes/Routes";

class App extends Component {
  render() {
    return <Routes />;
  }
}

export default App;
